/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-fragments */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unneeded-ternary */
import { Card, Nav, Row, Spinner } from 'react-bootstrap';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { paymentNavItems } from '../../../constants/onlineStore';
import { useOnlineStore } from '../../../contexts/onlineStoreContext';
import DeliveryAddress from '../DeliveryAddress';
import AdditionalData from '../AdditionalData';
import Cart from '../Cart';
import FinancingModal from '../Financing/FinancingModal';
import PaymentMethod from '../PaymentMethod';
import CustomerSelection from '../CustomerSelection';
import { useAuth } from '../../../contexts/authContext';
import userHasRoles from '../../../utils/userHasRoles';
import { Role } from '../../../constants/role';
import { Logs } from '../Logs';
import { BudgetEditLayout } from '../../BudgetEditLayout';
import { InvoiceStatus } from '../../../constants/invoiceStatus';
// import InsuranceMethod from '../Insurance';
import Branch from '../Branch';

interface Props {
    invoice: any;
    disabled: any;
    loading?: boolean;
    showLogsOption?: boolean;
    tab?: number;
}

interface PaymentNavItem {
    name: string;
    step: number;
}

const PaymentAndDelivery: React.FC<Props> = ({
    invoice,
    disabled,
    loading,
    showLogsOption,
    tab,
}) => {
    const location = useLocation();
    const pathName = location.pathname.split('/', 2);

    const { 
        showFinacingModal, 
        setShowFinacingModal,
    } = useOnlineStore();

    const [paymentItem, setPaymentItem] = useState(0);

    const { user } = useAuth();
    const isIntegratorAndContributor = userHasRoles(user, [
        Role.Integrator,
        Role.Contributor,
        Role.Manager,
    ]);

    const isAllowedToAlterBranch = userHasRoles(user, [
        Role.Administrator,
        Role.CommercialSupervisor,
    ]);

    const getNavItems = () => {
        let filteredNavItems = paymentNavItems;

        if (isIntegratorAndContributor || !showLogsOption) {
            filteredNavItems = filteredNavItems.filter(
                (nav: PaymentNavItem) => nav.name !== 'Logs',
            );
        }

        if (
            !isAllowedToAlterBranch ||
            invoice.status === InvoiceStatus.Cart ||
            invoice.status === InvoiceStatus.Budget ||
            invoice.status === InvoiceStatus.BudgetExpired
        ) {
            filteredNavItems = filteredNavItems.filter(
                (nav: PaymentNavItem) => nav.name !== 'Filial',
            );
        }

        return filteredNavItems;
    };

    let navItems: PaymentNavItem[] = getNavItems();

    const isOnlineStore: boolean =
        pathName[1] === 'kits-prontos' ||
        pathName[1] === 'monte-seu-gerador' ||
        pathName[1] === 'sales'
            ? true
            : false;

    function replaceResumeByPaymentMethodNavItems(
        navigationItems: PaymentNavItem[],
    ): PaymentNavItem[] {
        const navItemsWithPaymentMethod: PaymentNavItem[] = [
            {
                name: 'Método de pagamento',
                step: 0,
            },
        ];

        navigationItems = navigationItems.filter(
            (nav) =>
                nav.name !== 'Método de pagamento' && nav.name !== 'Resumo',
        );

        return navItemsWithPaymentMethod.concat(navigationItems);
    }

    if (isOnlineStore) {
        navItems = replaceResumeByPaymentMethodNavItems(navItems);
    }

    useEffect(() => {
        setPaymentItem(tab ?? 0);
    }, [invoice.id, tab]);

    return (
        <React.Fragment>
            <Card
                style={{
                    width: '100%',
                    backgroundColor: '#fafafa',
                    border: '1px solid #f2f2f2',
                }}
            >
                <Card.Body>
                    <Nav activeKey={paymentItem} className={'mt-n3'}>
                        {navItems.map((item, index: any) => (
                            <Nav.Item key={index}>
                                <Nav.Link
                                    className={'p-3'}
                                    style={
                                        paymentItem === item.step
                                            ? {
                                                  borderBottom:
                                                      '2px solid #F2994A',

                                                  color: '#F2994A',
                                                  fontWeight: 600,
                                              }
                                            : {
                                                  borderBottom:
                                                      '1px solid #F2F2F2',

                                                  color: '#707070',
                                              }
                                    }
                                    eventKey={item.name}
                                    onClick={() => {
                                        setPaymentItem(item.step);
                                    }}
                                >
                                    {item.name}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                    {loading && (
                        <Row
                            className={
                                'align-items-center justify-content-center'
                            }
                        >
                            <Spinner
                                animation={'border'}
                                size={'sm'}
                                style={{ color: '#666' }}
                            />
                        </Row>
                    )}
                    {!loading && paymentItem === 0 && (
                        <>
                            {invoice.status === InvoiceStatus.Budget &&
                                pathName[1] === 'orcamentos' && (
                                    <BudgetEditLayout
                                        disabled={disabled}
                                        invoice={invoice ?? {}}
                                    />
                                )}
                            {invoice.status !== InvoiceStatus.Budget && (
                                <>
                                    {isOnlineStore && (
                                        <PaymentMethod
                                            disabled={disabled}
                                            invoice={invoice ?? {}}
                                        />
                                    )}
                                    <Cart
                                        disabled={disabled}
                                        paymentDeliveryEditing
                                        invoice={invoice ?? {}}
                                    />
                                </>
                            )}
                        </>
                    )}
                    {!loading && paymentItem === 1 && (
                        <CustomerSelection
                            disabled={disabled}
                            invoice={invoice ?? {}}
                        />
                    )}
                    {!loading && paymentItem === 2 && (
                        <DeliveryAddress
                            disabled={disabled}
                            invoice={invoice ?? {}}
                        />
                    )}
                    {!loading && paymentItem === 3 && !isOnlineStore && (
                        <PaymentMethod
                            disabled={disabled}
                            invoice={invoice ?? {}}
                        />
                    )}
                    {!loading && paymentItem === 4 && (
                        <AdditionalData
                            disabled={disabled}
                            invoice={invoice ?? {}}
                        />
                    )}
                    {/* {!loading && paymentItem === 5 && (
                        <InsuranceMethod invoice={invoice ?? {}} />
                    )} */}
                    {!loading && paymentItem === 6 && (
                        <Branch invoice={invoice ?? {}} />
                    )}
                    {!loading && paymentItem === 7 && (
                        <Logs invoice={invoice} />
                    )}
                    <FinancingModal
                        invoice={invoice ?? {}}
                        disabled={disabled}
                        onHide={() => {
                            setShowFinacingModal(false);
                        }}
                        show={showFinacingModal}
                    />
                </Card.Body>
            </Card>
        </React.Fragment>
    );
};

PaymentAndDelivery.propTypes = {
    invoice: PropTypes.object,
    disabled: PropTypes.bool,
    showLogsOption: PropTypes.bool,
    tab: PropTypes.number,
};

export default PaymentAndDelivery;
